/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'empty-damage': {
    width: 34,
    height: 34,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M30.333.333a3.333 3.333 0 013.334 3.334v26.666a3.333 3.333 0 01-3.334 3.334H3.667a3.333 3.333 0 01-3.334-3.334V3.667A3.333 3.333 0 013.667.333h26.666zm-20 20.69L3.666 27.69v2.643h15.976l-9.309-9.31zm16.667-5L18.523 24.5l5.833 5.833h5.977V19.356L27 16.024zm3.333-12.356H3.667v19.31l6.666-6.667 5.833 5.833L27 11.31l3.333 3.332V3.667zm-15 1.666a5 5 0 110 10 5 5 0 010-10zm0 3.334a1.667 1.667 0 100 3.333 1.667 1.667 0 000-3.333z" _fill="#231F20" fill-rule="evenodd"/>'
  }
})
